
export class Organization {
  id: number;
  create_date : string;
  update_date : string;
  delete_date : string;
  uuid: string;
  name: string;
  description : string;
  site_url : string;
  parent_id: number | null;
  constructor() {
    this.id = 0;
    this.create_date  = "";
    this.update_date = "";
    this.delete_date = "";
    this.uuid = "";
    this.name = "";
    this.description = "";
    this.site_url = "";
    this.parent_id = null;
  }
}


